import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { style: {"vertical-align":"top","width":"50%"} }
const _hoisted_2 = { style: {"vertical-align":"top"} }

import {  ref, watch } from "vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import Insurance, {sortInsuranceByNumber} from "@/shared/model/Insurance";

interface Props {
  insurances:Insurance[],
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectInsuranceComponent',
  props: {
    insurances: {}
  },
  setup(__props: any) {

const props = __props



const _shoppingCartStore = useShoppingCartStore();
const _store = ref<Insurance[]>([])

function onAdd(insurance: Insurance) {
  _shoppingCartStore.addInsurance(insurance)
  _store.value = _store.value.filter(t=>t.id!=insurance.id)
}
function onRemove(insurance: Insurance) {
  _shoppingCartStore.removeInsurance(insurance)
  _store.value = sortInsuranceByNumber([..._store.value,insurance])
}

watch((props),()=>{
  _store.value=[...props.insurances]
},{immediate:true})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", null, [
    _cache[2] || (_cache[2] = _createElementVNode("tr", null, [
      _createElementVNode("th", { style: {"text-align":"center"} }, " Lager "),
      _createElementVNode("th", { style: {"text-align":"center"} }, " Ausgewählt ")
    ], -1)),
    _createElementVNode("tr", null, [
      _createElementVNode("td", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_store.value, (insurance) => {
          return (_openBlock(), _createBlock(SogCardActions, {
            key: insurance,
            "is-toolbar": true
          }, {
            default: _withCtx(() => [
              _createVNode(SogCardActionButton, {
                onClick: ($event: any) => (onAdd(insurance))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(insurance.insuranceNumber), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(_toDisplayString(insurance.evb), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _createElementVNode("td", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_shoppingCartStore).getCurrentItem().shoppingCartItem.insurances, (insurance) => {
          return (_openBlock(), _createBlock(SogCardActions, {
            key: insurance,
            "is-toolbar": true,
            style: {"justify-content":"flex-start","align-items":"start"}
          }, {
            default: _withCtx(() => [
              _createVNode(SogCardActionButton, {
                onClick: ($event: any) => (onRemove(insurance))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(insurance.insuranceNumber), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(_toDisplayString(insurance.evb), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ])
    ])
  ]))
}
}

})